import React, { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "./store/store";
import { setAuthToken } from "./api";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Studentprofilemain from "./pages/dashboard/student/studentprofile/studentprofilemain/studentprofilemain";
import Studentachievement from "./pages/dashboard/student/studentprofile/studentachievement/studentachievement";
import Studentfriends from "./pages/dashboard/student/studentprofile/studentfriends/studentfriends";
import Studenttutor from "./pages/dashboard/student/studentprofile/studenttutor/studenttutor";
import Messaging from "./pages/dashboard/messaging/messaging";
import Studentleaderboard from "./pages/dashboard/student/studentprofile/studentleaderboard/studentleaderboard";
import Studentlessons from "./pages/dashboard/student/studentlessons/studentlessons";
import Studentramruns from "./pages/dashboard/student/studentramruns/studentramruns";
import Forgotpassword from "./pages/forgotpassword/forgotpassword";
import Resetpassword from "./pages/resetpassword/resetpassword";
import Studentsettings from "./pages/dashboard/student/studentsettings/studentsettings";
import Studentaccountinfo from "./pages/dashboard/student/studentsettings/studentaccountinfo/studentaccountinfo";
import Studentsecurity from "./pages/dashboard/student/studentsettings/studentsecurity/studentsecurity";
import Studentpricing from "./pages/dashboard/student/studentsettings/studentpricing/studentpricing";
import Teacher from "./pages/dashboard/teacher";
import Teachercurricula from "./pages/dashboard/teacher/teachercurricula/teachercurricula";
import Teachersettings from "./pages/dashboard/teacher/teachersettimgs/teachersettings";
import Teacheraccountinfo from "./pages/dashboard/teacher/teachersettimgs/teacheraccountinfo/teacheraccountinfo";
import Teacherpricing from "./pages/dashboard/teacher/teachersettimgs/teacherpricing/teacherpricing";
import Teacherclasses from "./pages/dashboard/teacher/teacherclasses/teacherclasses";
import Teachercurriculum from "./pages/dashboard/teacher/teachercurricula/teachercurriculum/teachercurriculum";
import Studentclasses from "./pages/dashboard/student/studentclasses/studentclasses";
import Teacherclass from "./pages/dashboard/teacher/teacherclasses/teacherclass/teacherclass";
import Studentlesson from "./pages/dashboard/student/studentlessons/studentlesson/studentlesson";
import Studentclass from "./pages/dashboard/student/studentclasses/studentclass/studentclass";
import Teacherprofile from "./pages/dashboard/teacher/teacherprofile/teacherprofile";
import Teacheravatar from "./pages/dashboard/teacher/teacherprofile/teacheravatar/teacheravatar";
import Teacherstudents from "./pages/dashboard/teacher/teacherstudents/teacherstudents";
import Teacherteachers from "./pages/dashboard/teacher/teacherprofile/teacherteachers/teacherteachers";
import Teachertutor from "./pages/dashboard/teacher/teacherprofile/teachertutor/teachertutor";
import Teacherprofilemain from "./pages/dashboard/teacher/teacherprofile/teacherprofilemain/teacherprofilemain";
import Teacherstatistics from "./pages/dashboard/teacher/teacherprofile/teacherstatistics/teacherstatistics";
const Teacherdashboard = lazy(
  () => import("./pages/dashboard/teacher/teacherdashboard/teacherdashboard")
);
const Studentavatar = lazy(
  () =>
    import(
      "./pages/dashboard/student/studentprofile/studentavatar/studentavatar"
    )
);
const Quiz = lazy(
  () => import("./pages/dashboard/student/studentramruns/quiz/quiz")
);
const Student = lazy(() => import("./pages/dashboard/student"));
const Studentdashboard = lazy(
  () => import("./pages/dashboard/student/studentdashboard/studentdashboard")
);
const Studentprofile = lazy(
  () => import("./pages/dashboard/student/studentprofile/studentprofile")
);
const Ide = lazy(() => import("./pages/dashboard/ide/ide"));
const Signin = lazy(() => import("./pages/signin/signin"));
const Signup = lazy(() => import("./pages/signup/signup"));
const Notifications = lazy(
  () => import("./pages/dashboard/notifications/notification")
);

function App() {
  const state = useSelector((state: RootState) => ({
    token: state.user.token,
  }));

  const { token } = state;
  setAuthToken(token);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Signin />,
    },
    {
      path: "/login",
      element: <Signin />,
    },
    {
      path: "/signup/:usertype",
      element: <Signup />,
    },
    {
      path: "/forgot-password",
      element: <Forgotpassword />,
    },
    {
      path: "/reset-password/:token",
      element: <Resetpassword />,
    },
    {
      path: "/student/dashboard",
      element: <Student />,
      children: [
        {
          path: "/student/dashboard",
          element: <Studentdashboard />,
        },
        {
          path: "/student/dashboard/messaging",
          element: <Messaging />,
        },
        {
          path: "/student/dashboard/notifications",
          element: <Notifications />,
        },
        {
          path: "/student/dashboard/profile",
          element: <Studentprofile />,
          children: [
            {
              path: "/student/dashboard/profile",
              element: <Studentprofilemain />,
            },
            {
              path: "/student/dashboard/profile/achievement",
              element: <Studentachievement />,
            },
            {
              path: "/student/dashboard/profile/friends",
              element: <Studentfriends />,
            },
            {
              path: "/student/dashboard/profile/tutor",
              element: <Studenttutor />,
            },
            {
              path: "/student/dashboard/profile/leaderboard",
              element: <Studentleaderboard />,
            },
            {
              path: "/student/dashboard/profile/avatar",
              element: <Studentavatar />,
            },
          ],
        },
        {
          path: "/student/dashboard/settings",
          element: <Studentsettings />,
          children: [
            {
              path: "/student/dashboard/settings",
              element: <Studentaccountinfo />,
            },
            {
              path: "/student/dashboard/settings/account",
              element: <Studentaccountinfo />,
            },
            {
              path: "/student/dashboard/settings/security",
              element: <Studentsecurity />,
            },
            {
              path: "/student/dashboard/settings/billing",
              element: <Studentpricing />,
            },
          ],
        },
        {
          path: "/student/dashboard/lessons",
          element: <Studentlessons />,
        },
        {
          path: "/student/dashboard/lesson/:curriculumId",
          element: <Studentlesson />,
        },
        {
          path: "/student/dashboard/ramruns",
          element: <Studentramruns />,
        },
        {
          path: "/student/dashboard/ramruns/:ramrunId",
          element: <Quiz />,
        },
        {
          path: "/student/dashboard/classes",
          element: <Studentclasses />,
        },
        {
          path: "/student/dashboard/class/:classId",
          element: <Studentclass />,
        },
      ],
    },
    {
      path: "/teacher/dashboard",
      element: <Teacher />,
      children: [
        {
          path: "/teacher/dashboard",
          element: <Teacherdashboard />,
        },
        {
          path: "/teacher/dashboard/ramruns/:ramrunId",
          element: <Quiz />,
        },
        {
          path: "/teacher/dashboard/messaging",
          element: <Messaging />,
        },
        {
          path: "/teacher/dashboard/curricula",
          element: <Teachercurricula />,
        },
        {
          path: "/teacher/dashboard/curriculum/:curriculumId",
          element: <Teachercurriculum />,
        },
        {
          path: "/teacher/dashboard/classes",
          element: <Teacherclasses />,
        },
        {
          path: "/teacher/dashboard/class/:classId",
          element: <Teacherclass />,
        },
        {
          path: "/teacher/dashboard/settings",
          element: <Teachersettings />,
          children: [
            {
              path: "/teacher/dashboard/settings",
              element: <Teacheraccountinfo />,
            },
            {
              path: "/teacher/dashboard/settings/account",
              element: <Teacheraccountinfo />,
            },
            {
              path: "/teacher/dashboard/settings/security",
              element: <Studentsecurity />,
            },
            {
              path: "/teacher/dashboard/settings/billing",
              element: <Teacherpricing />,
            },
          ],
        },
        {
          path: "/teacher/dashboard/profile",
          element: <Teacherprofile />,
          children: [
            {
              path: "/teacher/dashboard/profile",
              element: <Teacherprofilemain />,
            },
            {
              path: "/teacher/dashboard/profile/teachers",
              element: <Teacherteachers />,
            },
            // {
            // 	path: '/student/dashboard/profile/achievement',
            // 	element: <Studentachievement />
            // },
            // {
            // 	path: '/student/dashboard/profile/friends',
            // 	element: <Studentfriends />
            // },
            {
              path: "/teacher/dashboard/profile/tutor",
              element: <Teachertutor />,
            },
            {
              path: "/teacher/dashboard/profile/statistics",
              element: <Teacherstatistics />,
            },
            {
              path: "/teacher/dashboard/profile/avatar",
              element: <Teacheravatar />,
            },
          ],
        },
        {
          path: "/teacher/dashboard/students",
          element: <Teacherstudents />,
        },
      ],
    },
    {
      path: "/ide",
      element: <Ide />,
    },
    {
      path: "/ide/:lessonId",
      element: <Ide />,
    },
    {
      path: "*",
      element: <Signin />,
    },
  ]);

  return (
    <div className="relative App">
      <GoogleOAuthProvider clientId="615548516742-tgnelddahl41q457r0amut844mpoecv5.apps.googleusercontent.com">
        <Suspense>
          <RouterProvider router={router} />
        </Suspense>
      </GoogleOAuthProvider>
    </div>
  );
}

export default App;
